import { useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectors } from '~/store/state-selectors';
const EMPTY_TEAM_INVITES = [];
export const useTeamInvites = ()=>{
    const { api } = useStoreActions();
    const hasUserInfo = useStore(selectors.user.hasUserInfo);
    const hasBusiness = useStore(selectors.user.hasBusiness);
    const isResetPasswordFlow = useStore(selectors.isResetPasswordFlow);
    const tokenCarriesNoBusiness = useStore((state)=>state.claims != null && !state.claims.businessId);
    const enabled = !isResetPasswordFlow && (hasUserInfo ? !hasBusiness : tokenCarriesNoBusiness);
    const { data, isLoading, isFetching, refresh, error } = useQueryState({
        queryKey: [
            QueryKeys.TeamInvites
        ],
        queryFn: ()=>api.user.getTeamInvites(),
        enabled
    });
    return {
        teamInvites: data !== null && data !== void 0 ? data : EMPTY_TEAM_INVITES,
        isLoading,
        isFetching,
        refresh,
        error
    };
};
